import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'
import { 
    generalStore, 
    authStore, 
    departmentStore, 
    storeStore, 
    userStore, 
    auditLogStore, 
    categoryStore, 
    productStore, 
    supplierStore,
    orderStore,
    publicHolidayStore,
    bankingDetailsStore,
    storeSupplierStore,
    reportStore,
    placeOrderStore,
    productTypeStore
 } from "./store/index.js";

Vue.use(Vuex);

/**
 * Any modules listed here will have their store state persisted.
 *
 * Anything persisted will keep the store the same across page reloads.
 *
 * Anything not persisted will reset to its default values when the browser
 * reloads the page. Using the Vue internal router for page navigation does
 * *not* reload the page in the browser, and therefore the store will not
 * be reset when we do this. Things that will reset the state for anything
 * not persisted:
 * - window.location.href
 * - user entering URL in browser and navigating manually
 * - browser refresh button
 *
 * We are not persisting the search store, for example, so that when
 * a user reloads a page it is reset to the default.
 *
 * See https://github.com/championswimmer/vuex-persist for more options
**/
const vuexLocal = new VuexPersistence({
    storage: window.localStorage, // where to persist the data (localStorage, sessionStorage, etc)
    modules: ['authStore'] // which modules will have their store state persisted
});

// const generalStore = stores.generalStore;
// const departmentStore = stores.departmentStore;

const store = new Vuex.Store({
    plugins: [
        vuexLocal.plugin
    ],
    modules: {
        generalStore,
        authStore,
        departmentStore,
        storeStore,
        userStore,
        auditLogStore,
        categoryStore,
        productStore,
        supplierStore,
        orderStore,
        publicHolidayStore,
        bankingDetailsStore,
        storeSupplierStore,
        reportStore,
        placeOrderStore,
        productTypeStore
    }
});

export default store;